<app-personalized-dialog [loading]="loadingAvailable()">
  <span dialog-title>Assigned Benefits</span>

  <div dialog-content style="min-height: 245px;">
    <!-- Benefits Edit Mode -->
    @if (isEditMode()) {
      <div class="animated fadeIn">
        <!-- Client Info -->
        @if (!loadingAvailable()) {
          <p class="text-muted mb-2 small">
            Eligibility based on: <strong>{{ trapQuantity }}</strong> traps • <strong>{{ capacity }}</strong> gal capacity • <strong>{{ restaurantCount }}</strong> locations
          </p>
        }

        <!-- Error State -->
        @if (!loadingAvailable() && errorMessage()) {
          <div class="alert alert-danger italic py-2">
            {{ errorMessage() }}
          </div>
        }

        <!-- Selection Phase (1. Select Benefits) -->
        <h6 class="mb-2 font-weight-bold" style="font-size: 14px;">1. Select Benefits</h6>
        @if (!loadingAvailable() && !errorMessage() && availableBenefits().length > 0) {
          <div class="mb-2">
            <!-- Tier 2.4: wj-flex-grid → app-kite-grid. Row-header `<app-checkbox>`
                 replaced by AG Grid built-in checkbox column via `rowSelection`
                 override on `availableGridOptions`. -->
            <app-kite-grid
              [columnDefs]="availableColumnDefs"
              [rowData]="availableBenefits()"
              [gridOptions]="availableGridOptions"
              [totalRecords]="availableBenefits().length"
              [pageSize]="availableBenefits().length || 1"
              (selectionChanged)="onAvailableSelectionChanged($event)">
            </app-kite-grid>
          </div>
        }

        <hr class="my-3">

        <!-- Configuration Phase (2. Configure Selected) -->
        <h6 class="mb-2 font-weight-bold" style="font-size: 14px;">2. Configure Selected ({{ selectedBenefits.length || 0 }})</h6>
        @if (selectedBenefits.length > 0) {
          <div class="benefits-grid-container shadow-sm border rounded">
            <!-- Tier 2.4: Configuration grid uses `<ag-grid-angular>` directly (NOT
                 the wrapper) because it embeds DateSelectorComponent via
                 frameworkComponents — which is registered only locally here.
                 The wrapper's frameworkComponents map is for system-wide shared
                 renderers; this component-specific renderer stays scoped here. -->
            <ag-grid-angular
              class="ag-theme-alpine w-full"
              style="width: 100%; display: block; max-height: 250px;"
              [rowData]="selectedBenefits"
              [columnDefs]="configurationColumnDefs"
              [gridOptions]="configurationGridOptions">
            </ag-grid-angular>
          </div>
        } @else {
          <div class="p-4 text-center border dashed rounded bg-light">
            <p class="text-muted mb-0 small italic">Please select at least one benefit above to configure.</p>
          </div>
        }
      </div>
    } @else {
      <!-- View Mode -->
      @if (ecoBenefits.length > 0) {
        <div class="row mt-2 animated fadeIn">
          <div class="col-12">
            <!-- Tier 2.4: wj-flex-grid → app-kite-grid (read-only summary). -->
            <app-kite-grid
              [columnDefs]="viewColumnDefs"
              [rowData]="ecoBenefits"
              [totalRecords]="ecoBenefits.length"
              [pageSize]="ecoBenefits.length || 1">
            </app-kite-grid>
          </div>
        </div>
      } @else {
        <div class="p-5 text-center animated fadeIn">
          <i class="fa fa-gift text-muted fa-3x mb-3"></i>
          <p class="text-muted h5">No additional benefits assigned to this client.</p>
        </div>
      }
    }
  </div>

  <div dialog-actions class="d-flex justify-content-end gap-2 mt-3">
    @if (isEditMode()) {
      <app-button variant="secondary" (onClick)="toggleEdit()">Cancel</app-button>
      <app-button variant="primary" (onClick)="save()" [disabled]="loadingAvailable() || selectedBenefits.length === 0">
        Assign & Configure Benefits
      </app-button>
    } @else {
      <app-button variant="blue-text" (onClick)="toggleEdit()">
        <i class="fa fa-edit mr-1"></i> Edit
      </app-button>
      <app-button variant="secondary" (onClick)="activeModal.dismiss()">
        Close
      </app-button>
    }
  </div>
</app-personalized-dialog>
